import { tss } from "tss-react";
import { backgroundColor, boxShadow, panelHeaderHeight, panelHeaderColor } from "./common";

var useStyles = tss.create({
    leftRoot: {
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        width: 300,
        height: panelHeaderHeight,
        userSelect: "none",
    },
    header: {
        display: "inline-flex",
        width: 300,
        height: panelHeaderHeight,
        cursor: "pointer",
        boxShadow: boxShadow,
        //backgroundColor: panelHeaderColor,
        alignItems: "center",
        color: "#283C50",
        background: 'rgba(34,45,69,.9)', 
        borderTop: '1px solid rgba(255,255,255,.05)',
        " &.light-theme": {
            background: 'rgba(32,32,32,.6)'
        }
    },
    title: {
        height: "100%",
        maxWidth: 130,
        color: "white",
        paddingLeft: 0,
        paddingTop: 12,
    },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        width: "100%",
        minHeight: "calc(100vh - 100px)",
        transition: "height 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms, width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
        boxShadow: boxShadow,
        backgroundColor: backgroundColor,
    },
    layers: {
        display: "flex",
        flexDirection: "column",
        minHeight: "35vh",
        position: "relative",
        top: 1,
    },
    properties: {
        paddingLeft: 12,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        flexGrow: 0.6,
    },
    addObject: {
        height: 40,
        display: "flex",
        alignItems: "center",
        width: "100%",
        boxShadow: boxShadow,
        backgroundColor: backgroundColor,
        marginBottom: -1,
        zIndex: 10,
    },
    divider: {
        height: 2,
        backgroundColor: "rgb(0 0 0 / 10%)",
    },
    right: {
        position: "absolute",
        right: 0,
        height: panelHeaderHeight,
    },
    relative: {
        position: "relative",
    },
});
export default useStyles;
